import axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'

import {
  ComparativeDisplayType,
  RollingType
} from 'types/GlobalKpiOption'
import { ShowPerEnum } from 'types/GlobalMetric'
import { VariantOption } from 'types/GlobalVariantOption'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/variant-options`

export async function create(data: {
  widget_id: string
  variant_kpi_template_id: string
  title: string
}) {
  return axios.post<{ data: VariantOption }>(
    URL,
    { data },
    parseAuthenticationHeader()
  )
}

export async function update(
  id: string,
  data: {
    active_show_per?: ShowPerEnum | null
    title?: string
    number_of_decimals?: number
    rolling_active?: RollingType | null
    comparative_display_type?: ComparativeDisplayType
  }
) {
  return axios.patch(`${URL}/${id}`, { data }, parseAuthenticationHeader())
}

export async function destroy(id: string) {
  return axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}
